"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryMovementCategory = exports.InventoryState = exports.InventoryMovementType = exports.InventoryDetailExceptionType = void 0;
const business_types_1 = require("@deliverr/business-types");
Object.defineProperty(exports, "InventoryMovementCategory", { enumerable: true, get: function () { return business_types_1.InventoryMovementCategory; } });
Object.defineProperty(exports, "InventoryMovementType", { enumerable: true, get: function () { return business_types_1.InventoryMovementType; } });
Object.defineProperty(exports, "InventoryState", { enumerable: true, get: function () { return business_types_1.InventoryState; } });
// TODO:Deprecation:JIRA(IM-1301): Remove this once all clients have been updated to use @deliverr/business-types
/**
 * @deprecated definition has been moved to @deliverr/business-types
 * If you would like to use/modify these types please refer to `@deliverr/business-types` in lib-commons
 */
var InventoryDetailExceptionType;
(function (InventoryDetailExceptionType) {
    InventoryDetailExceptionType["NODE_NO_PRODUCT"] = "NODE_NO_PRODUCT";
})(InventoryDetailExceptionType || (exports.InventoryDetailExceptionType = InventoryDetailExceptionType = {}));
//# sourceMappingURL=WarehouseInventory.js.map